import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PipesModule } from "../shared/pipes/pipes.module";
import { ComponentsModule } from '../shared/components/components.module';

import { WordRoutingModule} from './word-routing.module';

import { HomonymComponent } from './homonym/homonym.component';
import { WordComponent } from './word.component';
import { JasoIndexHomonymComponent } from './homonym/jaso-index-homonym.component';
import { HomonymWordDispComponent } from './homonym/homonym-word-disp.component';
import { HomonymWordItemComponent } from './homonym/homonym-word-item.component';
import { WordListHelpComponent } from './word-list-help/word-list-help.component';
import {SajaseungeoComponent} from "./sajaseungeo/sajaseungeo.component";


@NgModule({
  declarations: [
    HomonymComponent,
    WordComponent,
    JasoIndexHomonymComponent,
    HomonymWordDispComponent,
    HomonymWordItemComponent,
    WordListHelpComponent,
    SajaseungeoComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    ComponentsModule,
    WordRoutingModule,
  ],
  providers: [
  ],
  exports: [
    WordComponent,
  ],
})
export class WordModule {}
